import { DATE_FORMAT, truncateText, useUserAccess } from '@ui-framework/index';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import MoreHoriIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Divider } from '@mui/material';
import Currency from '@product-framework/components/Currency';

const valueOnly = true;

function actions(original, props, accessorFunctionsAdditional) {
  const [anchorEl, setAnchorEl] = useState(null);

  const { pageIndex, pageSize } = props.table.getState().pagination;
  const currentIndex = pageIndex * pageSize + props.row.index; // global index

  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex >= props.table.options.rowCount - 1;
  const userAccess = useUserAccess();

  const handleOpen = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const menuItems = [
    {
      label: 'Edit',
      onClick: () => {
        accessorFunctionsAdditional.setSelected(original.id, null);
        handleClose();
      },
    },
    {
      label: 'Delete',
      onClick: () => {
        accessorFunctionsAdditional.setSelectedDeleteId(original.id);
        handleClose();
      },
    },
    {
      type: 'Divider',
      label: 'div1',
    },
    {
      label: 'Add New Above',
      onClick: () => {
        const priority = parseInt(original?.priority || 0, 10);
        const newPriority = priority + 1;
        accessorFunctionsAdditional.setSelected(-1, newPriority);
        handleClose();
      },
    },
    {
      label: 'Add New Below',
      onClick: () => {
        const priority = parseInt(original?.priority || 0, 10);
        const newPriority = priority - 1;
        accessorFunctionsAdditional.setSelected(-1, newPriority);
        handleClose();
      },
    },
    {
      type: 'Divider',
      label: 'div2',
    },
    {
      label: 'Move Up',
      isFirstItem,
      onClick: () => {
        const priority = parseInt(original?.priority || 0, 10);
        const newPriority = priority + 1;
        accessorFunctionsAdditional.moveRateRule({
          id: original.id,
          priority: newPriority,
        });
      },
    },
    {
      label: 'Move Down',
      isLastItem,
      onClick: () => {
        const priority = parseInt(original?.priority || 0, 10);
        const newPriority = priority - 1;
        accessorFunctionsAdditional.moveRateRule({
          id: original.id,
          priority: newPriority,
        });
      },
    },
  ];
  return (
    <>
      {!userAccess?.isUserReadonly() && (
        <IconButton size="small" variant="outlined" onClick={handleOpen}>
          <MoreHoriIcon />
        </IconButton>
      )}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {menuItems.map(item => {
          if (item?.type === 'Divider') {
            return <Divider key={item.label} />;
          }
          if (item.isFirstItem === true || item.isLastItem === true) {
            return null;
          }
          return (
            <MenuItem key={item.label} onClick={() => item.onClick()}>
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}

function client(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(original.client, valueOnly);
}

function industry(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(
    original.industry,
    valueOnly,
  );
}

function brand(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(original.brand, valueOnly);
}

function productLine(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(
    original.productLine,
    valueOnly,
  );
}

function model(original) {
  return truncateText(original?.model?.join(', ') || '');
}

function serviceSite(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(
    original?.serviceSite,
    valueOnly,
  );
}

function serviceType(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(
    original?.serviceType,
    valueOnly,
  );
}

function repairSeverity(original, props, accessorFunctionsAdditional) {
  return accessorFunctionsAdditional.rulesFormatter(
    original?.repairSeverity,
    valueOnly,
  );
}

function repairCode(original) {
  return truncateText(original?.repairCode?.join(', ') || '');
}

function laborRate(original) {
  return <Currency>{original?.rule?.event?.params?.laborRate}</Currency>;
}

function travelRate(original) {
  return <Currency>{original?.rule?.event?.params?.travelRate}</Currency>;
}

function effectiveDate(original) {
  const dated = original?.effectiveDate;
  return dated ? dayjs(dated).format(DATE_FORMAT.LONG_DATE) : '';
}

function endDate(original) {
  const dated = original?.endDate;
  return dated ? dayjs(dated).format(DATE_FORMAT.LONG_DATE) : '';
}

export {
  actions,
  client,
  industry,
  brand,
  productLine,
  model,
  serviceSite,
  serviceType,
  repairSeverity,
  repairCode,
  laborRate,
  travelRate,
  effectiveDate,
  endDate,
};
